var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "filters__select-boxes-item",
      class: [_vm.icon ? "has-icon" : ""],
      on: { click: _vm.handleClick }
    },
    [
      _vm.icon
        ? _c("i", { class: [_vm.color ? "color--" + _vm.color : "", _vm.icon] })
        : _vm._e(),
      _vm._v(" "),
      _vm.image
        ? _c("img", {
            staticClass: "filters__select-boxes-item__image",
            attrs: { src: _vm.image.src, alt: _vm.image.alt }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("span", { staticClass: "filters__select-boxes-item__label" }, [
        _vm._v(_vm._s(_vm.label))
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }